<template>
  <section class="footer bg-black text-white text-left p-2 lg:p-4 lg:mt-4">
    <div class="container mx-auto">
      <div class="grid grid-cols-1 sm:grid-cols-4 place-items-start gap-1">
        <div class="col-md-4">
          <h3 class="text-lg font-bold uppercase mb-4 font-heading">
            about us
          </h3>
          <p class="text-sm">
            Upskill is a peer to peer skill sharing platform. It enables
            individuals and organizations to share skills and exchange technical
            knowledge to bridge the skills gap in Bangladesh.
          </p>
          <div class="sm:flex">
            <img class="mt-1" src="../assets/ict.png" alt />
            <img class="mt-1" src="../assets/holon.png" alt />
            <img class="mt-1" src="../assets/stbd.png" alt />
          </div>
        </div>
        <div class="col-md-2">
          <h3 class="text-lg font-bold uppercase mb-4 font-heading">
            Helpful Links
          </h3>
          <ul class="text-sm text-UGreen-light">
            <li>
              <a class="" href="https://upskill.com.bd/faq">FAQ </a>
            </li>
            <li>
              <a class="hover-link" href="https://upskill.com.bd/privacy"
                >Terms and Conditions</a
              >
            </li>
            <li>
              <a class="hover-link" href="https://upskill.com.bd/privacy"
                >Privacy Statement</a
              >
            </li>
            <li>
              <a class="hover-link" href="https://upskill.com.bd/about"
                >About Upskill</a
              >
            </li>
          </ul>
        </div>
        <div class="col-md-2">
          <h3 class="text-lg font-bold uppercase mb-4 font-heading">contact</h3>
          <div class="text-sm">
            <p>
              Upskill, Level 3, House 9 <br />
              Lane - 17/E, Dhaka 1213
            </p>
            <p class="footer-phone">
              <!-- <i class="fa fa-phone"></i> -->
              0171 4053 213
            </p>
            <p class="footer-email">
              <!-- <i class="fa fa-envelope"></i> -->
              rafi.upskill@gmail.com
            </p>
            <!-- <h4 class="footer-widget-title">Follow Us</h4>
            <div id="social-follow"></div> -->
          </div>
        </div>
        <div class="col-md-4">
          <h3 class="text-lg font-bold uppercase mb-4 font-heading">
            Subscribe to our newsletter
          </h3>
          <div class="footer-newsletter">
            <div class="row">
              <div class="col-md-12">
                <input
                  type="text"
                  class="border-2 border-UGreen-light w-full bg-transparent p-2"
                  placeholder="Type your email"
                  v-model="email"
                />
              </div>
              <div class="col-md-12">
                <btn
                  class="
                    bg-transparent
                    border-2 border-UGreen-light
                    text-UGreen-light
                    font-bold
                    mt-2
                    w-1/2
                  "
                >
                  Submit
                </btn>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import btn from "@/components/BaseButton.vue";
export default {
  components: {
    btn,
  },
  data() {
    return {
      email: "",
    };
  },
  mounted() {
    let linkedin = document.createElement("script");
    linkedin.setAttribute("type", "IN/FollowCompany");
    linkedin.setAttribute("data-id", "14598438");
    linkedin.setAttribute("data-counter", "bottom");
    // document.getElementById("social-follow").appendChild(linkedin);
  },
  methods: {
    subscribe() {
      this.$upskill
        .subscribe({ email: this.email })
        .then(() => {
          this.SuccessAlert("Successfully subscribed to the newsletter!");
        })
        .catch((err) => {
          this.ErrorAlert(err.data.message);
        });
    },
  },
};
</script>
<style scoped>
.mt-1 {
  width: 85px;
  height: auto;
}
</style>
